import { SkillLevelEnum } from '../enums/skill-levels';

export const SKILL_LEVELS = {
	[SkillLevelEnum.AllLevels]: {
		value: SkillLevelEnum.AllLevels,
		name: 'all levels',
	},
	[SkillLevelEnum.Beginner]: {
		value: SkillLevelEnum.Beginner,
		name: 'beginner',
	},
	[SkillLevelEnum.Intermediate]: {
		value: SkillLevelEnum.Intermediate,
		name: 'intermediate',
	},
	[SkillLevelEnum.Advanced]: {
		value: SkillLevelEnum.Advanced,
		name: 'advanced',
	},
};

export const SKILL_LEVEL_NAMES: Record<SkillLevelEnum, string> = {
	[SkillLevelEnum.AllLevels]: 'All levels',
	[SkillLevelEnum.Beginner]: 'Beginner',
	[SkillLevelEnum.Intermediate]: 'Intermediate',
	[SkillLevelEnum.Advanced]: 'Advanced',
};
